import React from 'react';
import { connect } from 'react-redux';
import taskGroupsActions from '../../store/task-groups/action-creators/index';

const getHasTag = (tags, tagGuid) => {
  return !!tags.find(tag => tag.tagGuid === tagGuid);
};

const TaskGroupTagsManage = (props) => {

  return (
    <div className="list-group list-group-flush tag-list">
      {props.taskGroup &&
        props.tags.map((tag, index) => (
          <div
            className="align-items-center d-flex justify-content-between list-group-item"
            key={index.toString()}
          >
            <p>{tag.name}</p>
            {getHasTag(props.taskGroup.tags, tag.guid) ? (
              <button
                data-tip="Remove tag"
                className="button default small"
                onClick={() => props.detachTaskGroupTag(props.taskGroup.taskGroupGuid, tag.guid)}
              >
                <i className="fa fa-times" />
              </button>
            ) : (
              <button
                data-tip="Add tag"
                className="button default small"
                onClick={() => props.attachTaskGroupTag(props.taskGroup.taskGroupGuid, tag.guid)}
              >
                <i className="fa fa-plus" />
              </button>
            )}
          </div>
        ))}
    </div>
  );
};

// ----------------------
// Redux Mappings
// ----------------------

const mapDispatchToProps = (dispatch) => {
  return {
    attachTaskGroupTag: (taskGroupGuid, tagGuid) =>
      dispatch(taskGroupsActions.attachTaskGroupTag(taskGroupGuid, tagGuid)),
    detachTaskGroupTag: (taskGroupGuid, tagGuid) =>
      dispatch(taskGroupsActions.detachTaskGroupTag(taskGroupGuid, tagGuid)),
  };
};

export default connect(null, mapDispatchToProps)(TaskGroupTagsManage);
